import React, { useState, useEffect } from 'react';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import { collections as collectionsApi, progress as progressApi } from '../api';import './Study.css';

const Study = () => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const isPreview = searchParams.get('preview') === 'true';
  const sessionSize = parseInt(searchParams.get('size')) || 999;
  const domainFilter = searchParams.get('domain');

  const [cards, setCards] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [flipped, setFlipped] = useState(false);
  const [rated, setRated] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        if (isPreview) {
          const coll = await collectionsApi.getById(id);
          setCards(coll.preview || []);
        } else {
          const data = await progressApi.getSession(id, sessionSize, domainFilter);
          setCards(data.cards);
        }
      } catch (err) {
        console.error(err);
      }
      setLoading(false);
    };
    load();
  }, [id, isPreview]);

  if (loading) return <div className="loading">Loading...</div>;
  if (!cards.length) return <div className="loading">No cards available</div>;

  const card = cards[currentIndex];
  const totalCards = cards.length;

  const handleRate = async (rating) => {
    if (!isPreview) {
      progressApi.rate(card.cardId, id, rating).catch(console.error);
    }
    setRated({ ...rated, [card.cardId]: rating });
    if (currentIndex < totalCards - 1) {
      setCurrentIndex(currentIndex + 1);
      setFlipped(false);
    }
  };

  const ratingColors = { 1: '#ef4444', 2: '#f97316', 3: '#eab308', 4: '#84cc16', 5: '#22c55e' };

  return (
    <div className="study-page">
      <nav className="nav">
        <div className="nav-content">
          <Link to="/" className="logo">C3</Link>
          <Link to="/dashboard" className="btn-secondary">Dashboard</Link>
        </div>
      </nav>

      <div className="study-container">
        <div className="study-header">
          <div className="progress-bar">
            <div className="progress-fill" style={{ width: `${(Object.keys(rated).length / totalCards) * 100}%` }} />
          </div>
          <div className="progress-text">{Object.keys(rated).length} / {totalCards} cards studied</div>
        </div>

        <div className="flashcard" onClick={() => setFlipped(!flipped)}>
          {!flipped ? (
            <div className="card-side card-front-side">
              <div className="card-domain-label">{card.domain}</div>
              <div className="card-content"><h2>{card.front}</h2></div>
              <div className="flip-hint">Click to flip</div>
            </div>
          ) : (
            <div className="card-side card-back-side">
              <div className="card-domain-label">{card.domain}</div>
              <div className="card-content">
                {card.back && <><h3>Answer</h3><p>{card.back}</p></>}
                {card.explanation && (
                  <div className="card-explanation"><h4>Explanation</h4><ReactMarkdown>{card.explanation}</ReactMarkdown></div>
                )}
                {card.links?.length > 0 && (
                  <div className="card-links"><h4>Resources</h4>
                    {card.links.map((link, i) => (
                      <a key={i} href={link.url} target="_blank" rel="noopener noreferrer">{link.text} →</a>
                    ))}
                  </div>
                )}
              </div>
            </div>
          )}
        </div>

        {flipped && (
          <div className="rating-section">
            <p>How well did you know this?</p>
            <div className="rating-buttons">
              {[1, 2, 3, 4, 5].map(r => (
                <button key={r} onClick={() => handleRate(r)} className="rating-btn" style={{ background: ratingColors[r] }}>{r}</button>
              ))}
            </div>
          </div>
        )}

        {currentIndex === totalCards - 1 && Object.keys(rated).length === totalCards && (
          <div className="session-complete">
            <h2>{isPreview ? 'Preview Complete!' : 'Session Complete!'}</h2>
            <p>You studied {totalCards} cards</p>
            {isPreview ? (
              <Link to={`/collection/${id}`} className="btn-primary">Purchase Full Collection</Link>
            ) : (
              <Link to={`/progress/${id}`} className="btn-primary">View Progress</Link>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Study;
